export default __webpack_public_path__ + "static/media/signup_2.f3ae2959.jpg";